import React from 'react';
import Screen from '../../components/Common/ScreenLayout/Screen';
import Content from '../../components/Common/ScreenLayout/Content';
import accountScreenOption, {
  MY_ACCOUNT_OPTIONS,
} from '../../propTypes/myAccountOptions';
import Profile from '../../components/MyAccount/Profile';
import { ScreenWrapper } from '../../navigation/styles';
import { TOP_BAR_HEIGHT } from '../../constants';

const MyAccountScreen = ({ selectedOption }) => (
  <ScreenWrapper>
    <Screen>
      <Content
        backgroundColor={'var(--color-bg-primary)'}
        style={{ justifyContent: 'center', padding: TOP_BAR_HEIGHT }}
      >
        {selectedOption === MY_ACCOUNT_OPTIONS.PROFILE && (
          <div>
            <Profile />
          </div>
        )}
      </Content>
    </Screen>
  </ScreenWrapper>
);

MyAccountScreen.propTypes = {
  selectedOption: accountScreenOption,
};

export default MyAccountScreen;
